import { GlobalConfig } from '@/services/gloabl.config';

export const resetResources = (layer: StoreLayerItem, deep = false) => {
  const { resources = {} } = layer.attrs;
  const resourceNames = Object.keys(resources ?? {});
  resourceNames?.forEach((resourceName) => {
    const colorIds = Object.keys(resources[resourceName] ?? {});
    if (!colorIds.length) return;
    colorIds.forEach((colorId) => {
      const items = resources[resourceName]?.[colorId];
      if (!items.length) return;
      resources[resourceName][colorId] = GlobalConfig.changeResourceType
        ? items.map((item) => {
            if (typeof item == 'string') {
              return {
                src: item
              };
            } else {
              return item;
            }
          })
        : items.map((item) => {
            if (typeof item == 'string') {
              return item;
            } else if (typeof item == 'object') {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              return (item as any)?.src;
            }
          });
    });
  });
  if (deep && layer.children?.length) {
    layer.children.forEach((kid) => {
      resetResources(kid, deep);
    });
  }
};
